import React from 'react';
import { Button, Modal } from 'antd';
import MyCreateAmountForm, {
  ICreateAmountFormValues,
} from './CreateAmountForm';
import { Amount } from '../CreateItinerary/CreateItineraryForm';
import { Vat } from '../../../graphql/datamodel.gen';

export interface ICreateAmountProps {
  visible: boolean;
  onOk: Function;
  onCancel: Function;
  onSubmit: (values: ICreateAmountFormValues) => any;
  editing?: boolean;
  amount?: Amount;
  vatTypes: Vat[];
}

const CreateAmount = (props: ICreateAmountProps) => {
  return <CreateAmountView {...props} />;
};

interface ICreateAmountViewProps extends ICreateAmountProps {}
interface ICreateAmountViewState {}

class CreateAmountView extends React.Component<
  ICreateAmountViewProps,
  ICreateAmountViewState
> {
  render(): React.ReactNode {
    return (
      <Modal
        destroyOnClose={true}
        cancelText={'Cerrar'}
        okText={this.props.editing ? 'Hecho' : 'Crear'}
        width={'20%'}
        title={this.props.editing ? 'Editar importe' : 'Crear nuevo importe'}
        centered={true}
        visible={this.props.visible}
        onCancel={() => this.props.onCancel()}
        footer={[
          <Button onClick={() => this.props.onCancel()}>Cerrar</Button>,
          <Button
            form="create-amount-form"
            key="submit"
            htmlType="submit"
            type={'primary'}
          >
            {this.props.editing ? 'Guardar cambios' : 'Crear importe'}
          </Button>,
        ]}
      >
        <MyCreateAmountForm
          vatTypes={this.props.vatTypes}
          onSubmit={this.props.onSubmit}
          amount={this.props.amount}
        />
      </Modal>
    );
  }
}

export default CreateAmount;
